import z from 'zod';

export const intString = z.string().regex(/^-?\d+$/);
export const intStringCoerced = intString.transform((val) => parseInt(val, 10));
